import Layout from "../views/layout/Layout";

export default {
    path: '/message',
    component: Layout,
    redirect: '/message/sys-message-record',
    meta: {title: '消息管理', icon: 'el-icon-bell'},
    children: [
        // {
        //     path: 'sys-message-config',
        //     name: 'sys-message-config',
        //     component: () => import('@/views/message/sys-message-config'),
        //     meta: {title: '站内消息配置', icon: 'product-cate'},
        //     auth: 'message:sys-message-config'
        // }, {
        //     path: 'sys-message-record',
        //     name: 'sys-message-record',
        //     component: () => import('@/views/message/sys-message-record'),
        //     meta: {title: '站内消息发送记录', icon: 'product-cate'},
        //     auth: 'message:sys-message-record'
        // }, {
        //     path: 'wechat-config',
        //     name: 'wechat-config',
        //     component: () => import('@/views/message/wechat-config'),
        //     meta: {title: '第三方消息配置', icon: 'product-cate'},
        //     auth: 'message:wechat-config'
        // }, {
        //     path: 'wechat-record',
        //     name: 'wechat-record',
        //     component: () => import('@/views/message/wechat-record'),
        //     meta: {title: '第三方消息发送记录', icon: 'product-cate'},
        //     auth: 'message:wechat-record'
        // }, {
        //     path: 'message-template-type',
        //     name: 'message-template-type',
        //     component: () => import('@/views/message/message-template-type'),
        //     meta: {title: '消息模版类型', icon: 'product-cate'},
        //     auth: 'message:message-template-type'
        // }, {
        //     path: 'message-control',
        //     name: 'message-control',
        //     component: () => import('@/views/message/message-control'),
        //     meta: {title: '消息控制', icon: 'product-cate'},
        //     auth: 'message:message-control'
        // },
        {
            path: 'messageControl',
            name: 'messageControl',
            component: () => import('@/views/message/messageControl'),
            meta: {title: '消息控制', icon: 'product-cate'},
            auth: 'message:messageControl'
        },  {
            path: 'wechat-config',
            name: 'wechat-config',
            component: () => import('@/views/message/wechatConfig'),
            meta: {title: '第三方消息配置', icon: 'product-cate'},
            auth: 'message:wechat-config'
        }, {
            path: 'sysMessageRecord',
            name: 'sysMessageRecord',
            component: () => import('@/views/message/sysMessageRecord'),
            meta: {title: '站内信发送记录', icon: 'product-cate'},
            auth: 'message:sysMessageRecord'
        }, {
            path: 'weChatRecord',
            name: 'weChatRecord',
            component: () => import('@/views/message/weChatRecord'),
            meta: {title: '微信公众号发送记录', icon: 'product-cate'},
            auth: 'message:weChatRecord'
        }, {
            path: 'weChatSubscribeRecord',
            name: 'weChatSubscribeRecord',
            component: () => import('@/views/message/weChatSubscribeRecord'),
            meta: {title: '微信订阅消息发送记录', icon: 'product-cate'},
            auth: 'message:weChatSubscribeRecord'
        }, {
            path: 'aliPayServiceRecord',
            name: 'aliPayServiceRecord',
            component: () => import('@/views/message/aliPayServiceRecord'),
            meta: {title: '支付宝服务提醒记录', icon: 'product-cate'},
            auth: 'message:aliPayServiceRecord'
        }, {
            path: 'upgrade-message',
            name: 'upgrade-message',
            component: () => import('@/views/message/upgrade-message'),
            meta: {title: '升级通知', icon: 'product-cate'},
            auth: 'message:message-control'
        }, {
            path: 'SMS-interface',
            name: 'SMS-interface',
            component: () => import('@/views/message/SMS-interface'),
            meta: {title: '短信接口管理', icon: 'product-cate'},
            auth: 'message:SMS-interface'
        }, {
            path: 'smsSendRecord',
            name: 'smsSendRecord',
            component: () => import('@/views/message/smsSendRecord'),
            meta: {title: '短信发送记录', icon: 'product-cate'},
            auth: 'message:smsSendRecord'
        }, {
            path: 'smsTemplate',
            name: 'smsTemplate',
            component: () => import('@/views/message/smsTemplate'),
            meta: {title: '短信模版管理', icon: 'product-cate'},
            auth: 'message:smsTemplate'
        }, {
            path: 'groupSending',
            name: 'groupSending',
            component: () => import('@/views/message/groupSending'),
            meta: {title: '群发功能', icon: 'product-cate'},
            auth: 'message:groupSending'
        }, {
            path: 'voiceAlert',
            name: 'voiceAlert',
            component: () => import('@/views/message/voiceAlert'),
            meta: {title: '语音提醒模块', icon: 'product-cate'},
            auth: 'message:voiceAlert'
        }]
}



// WEBPACK FOOTER //
// ./src/router/message.js